import React from "react";
import instagram from "../../images/l-instagram.svg";
import twitter from "../../images/l-youtube.svg";
import youtube from "../../images/l-twitter.svg";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container">
        <p>&copy; 2024 WhatzOn. All rights reserved</p>
        <ul className="f-social-menu">
          <li>
            <a href="javascript:void(0)">
              <img src={instagram} alt="instagram" />
            </a>
          </li>
          <li>
            <a href="javascript:void(0)">
              <img src={twitter} alt="twitter" />
            </a>
          </li>
          <li>
            <a href="javascript:void(0)">
              <img src={youtube} alt="youtube" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;